<template>
   <BaseModal
        :id="'static-update'"
        :title="title"
        :size="'lg'"
        message="Make any  changes and click Save"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit_update(single_object.id, global_index)">
                <FormDynamic
                    :form_format="form_format"
                    :form_data="single_object"
                    :array_options="array_options"
                    :for_update="true"
                />
                <CentralButtons /> 
            </form>
        </template>
    </BaseModal>
</template>

<script>

import FormResources    from    './form_resources'
import FormDynamic      from    '@/components/FormDynamic.vue'
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal        from    '@/components/BaseModal'
import CentralButtons   from    '@/components/CentralButtons'

export default {

    name:   'UpdateModal',
    props:  [
        'title',
        'rest_api',
        'notyf',
        'single_object',
        'global_index',
        "array_options",
        "breadcrumb",
    ],

     components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
        CentralButtons,
    },

    data(){
        return{
            form_format:    FormResources.form_format_modal,
        }
    },

    watch:{

        async "single_object.associate_id"(val)
        {
        if(val && this.single_object.supervisor_id) 
        {
            if(this.array_options.supervisor_id.find(item => item.id === this.single_object.supervisor_id).associate_id  === val)
            {
            this.notyf.error(`The associate must not be the same supervisor.`);
            this.single_object.associate_id = ''
            }
        }
        },
        async "single_object.supervisor_id"(val)
        {
        if(val && this.single_object.associate_id) 
        {
            if(this.array_options.supervisor_id.find(item => item.id === val).associate_id  === this.single_object.associate_id)
            {
            this.notyf.error(`The supervisor must not be the same associate.`);
            this.single_object.supervisor_id = ''
            }
        }
        },

        "single_object.days_per_week"(val){
            if(val < 0 || val > 7){
                this.single_object.days_per_week = 0
                this.notyf.error(`Error`)
            }
        },

        async 'single_object.census'(val)
        {
            if(val)
            {
                this.form_format[13].required = true
                this.form_format[13]['minlength'] = 0
            }
            else
            {
                this.form_format[13].required = false
                this.form_format[13]['minlength'] = ''
            }
        },

    },

    methods:{
        async initiate(id)
        {
            const response = await this.get(`${this.rest_api}/logged_minutes/${id}`)

            if(response.status)
            {
                this.single_object.total_shift_work_time = Number(this.single_object.total_shift_work_time) + Number(response.data.summed_minutes_available)
            }
            else
            {
                this.error_handling(response)
            }
        }
    },

    mounted(){

    }
    
}
</script>